import { render, staticRenderFns } from "./SearchBarSimple.vue?vue&type=template&id=6c31e9cf&scoped=true&"
import script from "./SearchBarSimple.vue?vue&type=script&lang=js&"
export * from "./SearchBarSimple.vue?vue&type=script&lang=js&"
import style0 from "./SearchBarSimple.vue?vue&type=style&index=0&id=6c31e9cf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c31e9cf",
  null
  
)

export default component.exports